<template>
  <v-container fluid>
    <v-row no-gutters>
      <v-spacer></v-spacer>
      <v-col sm="3">
        <v-layout row wrap class="mt-2 ml-2">
          <v-flex xs5>
            <v-menu
              v-model="menu1"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  outlined
                  dense
                  class="text1"
                  v-model="date1Formatted"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="date1"
                @input="menu1 = false"
              ></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs5 ml-2>
            <v-menu
              v-model="menu2"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  class="text2"
                  v-model="date2Formatted"
                  outlined
                  dense
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="date2"
                @input="menu2 = false"
              ></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs1 class="ml-1">
            <v-btn small color="#112A46" dark height="38px" @click="getLikes"
              >Go</v-btn
            >
          </v-flex>
        </v-layout>
      </v-col>
    </v-row>
    <v-row
      v-if="likes.length == 0"
      align="center"
      class="text-center"
      style="min-height:500px;"
    >
      <v-col>
        <h1 class="display-2 grey--text" style="text-align:center">
          No Likes Found
        </h1>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col cols="3" xl="3" lg="4" md="4" sm="4" v-for="(data, index) in likes" :key="index">
        <v-card
          class="mb-6 rounded-2 shadow-2"
          style="border-radius: 5px 5px 0 0;"
        >
          <v-row>
            <v-col cols="12" class="px-5">
              <v-card class="elevation-0 rounded-2">
                <v-img
                  tile
                  class="rounded-2"
                  height="255px"
                  v-if="
                    data.post.post_media[0] &&
                      data.post.post_media[0].media != ''
                  "
                  :src="s3BucketURL + data.post.post_media[0].media"
                ></v-img>
              </v-card>
            </v-col>
            <v-col cols="12" class="ml-1 pt-0">
              <v-row>
                <v-card-text
                  style="height:62px; overflow: hidden;
                      display: -webkit-box;
                      -webkit-line-clamp: 2;
                      -webkit-box-orient: vertical;"
                  class="text-md-body-1"
                >
                  <h3>{{ data.post.title ? data.post.title : "" }}</h3>
                  <h4>{{ data.post.description ? data.post.description : "" }}</h4>
                </v-card-text>
              </v-row>
              <div class="w-full d-flex justify-space-between">
                  <SvgIcon class="ml-1">
                    <template #icon>
                      <CalendarIcon></CalendarIcon>
                      <span class="text-sm">{{ data.created_date | dayDateFormat }} - {{ data.created_time | timeFormat }}</span>
                    </template>
                  </SvgIcon>

                <v-btn
                    small
                    elevation="0"
                    color="#008483"
                    tile
                    @click="showPostModel(data.post_id)"
                    dark
                    class="mr-2 rounded-2"
                >View Post</v-btn
                >
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>

    <post-model v-bind="postModel" @close="postModel.postID = null" />
    <v-pagination v-if="totalPages > 1" v-model="page" :length="totalPages"></v-pagination>
  </v-container>
</template>

<script>
import moment from "moment";
import PostModel from "./../../Feeds/Post/PostModel";
import SvgIcon from "@/components/Image/SvgIcon.vue";
import CalendarIcon from "@/assets/images/misc/calendar.svg";
export default {
  data() {
    return {
      postID: 0,
      likes: [],
      page: 1,
      perPage: null,
      totalPages: 1,
      date1: moment()
        .subtract(30, "days")
        .format("YYYY-MM-DD"),
      date2: moment().format("YYYY-MM-DD"),
      menu1: false,
      menu2: false,
      search: null,
      postModel: { postID: null, type: "details" },
    };
  },
  components: {CalendarIcon, SvgIcon, PostModel },
  props: {
    userID: { type: Number },
  },
  computed: {
    date1Formatted() {
      return moment(this.date1, "YYYY-MM-DD").format("Do MMM YYYY");
    },
    date2Formatted() {
      return moment(this.date2, "YYYY-MM-DD").format("Do MMM YYYY");
    },
  },
  watch: {
    userID() {
      this.page = 1;
      this.getLikes();
    },
    page() {
      this.getLikes();
    },
    search() {
      this.page = 1;
      this.getLikes();
    },
  },
  mounted() {
    this.getLikes();
  },
  methods: {
    getLikes() {
      this.showLoader('Loading');
      let url =
        "&page=" +
        this.page +
        "&per_page=9&from_date=" +
        this.date1 +
        "&end_date=" +
        this.date2;
      if (this.search != null && this.search != "") {
        url += "&term=" + this.search;
      }
      this.$http
        .get("admin/user-likes?user_id=" + this.userID + url)
        .then((response) => {
          if (response.status == 200 && response.data.status) {
            this.likes = response.data.data;
            this.totalPages = response.data.total_pages;
          }
        })
        .catch((error) => {
          this.errorChecker(error);
        }).finally(() => {
            this.hideLoader()
      });
    },
    showPostModel(postId) {
      this.postModel.postID = parseInt(postId);
      this.postModel.type = "details";
    },
  },
};
</script>

<style></style>
